<div class="c-dialog-template-body"
  [ngClass]="[
    hasSpaceY ? 'c-dialog-template-body--has-space-y' : '',
    hasPaddingY ? 'c-dialog-template-body--has-padding-y' : ''
  ]">
  <ng-content></ng-content>
</div>
